'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import LivingInArmeniaTemplateStyle from './style';
const HeroSection = dynamic(() => import('../../WhyArmenia/components/HeroSection'), {
	ssr: true,
});
const BalanceSection = dynamic(() => import('../components/BalanceSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ExpatSection = dynamic(() => import('@/sections/ExpatSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const StandardsSection = dynamic(() => import('../components/StandardsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const RecreationSection = dynamic(() => import('@/sections/RecreationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ModernLifeSection = dynamic(() => import('@/sections/ModernLifeSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const EnvironmentSection = dynamic(() => import('../components/EnvironmentSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const LivingInArmeniaTemplate = ({ pageData }) => {
	const { content } = pageData;
	const { hero, balance, expat, standards, recreation, modern_life, environment } = content;

	return (
		<LivingInArmeniaTemplateStyle>
			<HeroSection
				title={hero.title}
				description={hero.description}
			/>

			<BalanceSection
				title={balance.title}
				description={balance.description}
				items={balance.items}
			/>

			<ExpatSection
				title={expat.title}
				description={expat.description}
				items={expat.items}
			/>

			<StandardsSection
				title={standards.title}
				description={standards.description}
				items={standards.items}
			/>

			<RecreationSection
				title={recreation.title}
				description={recreation.description}
				items={recreation.items}
			/>

			<ModernLifeSection
				title={modern_life.title}
				description={modern_life.description}
				items={modern_life.items}
			/>

			<EnvironmentSection
				title={environment.title}
				items={environment.items}
			/>
		</LivingInArmeniaTemplateStyle>
	);
};

export default LivingInArmeniaTemplate;
